// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"72ebff86","453":"41898b38","636":"fb59b7cd"}[chunkId] + ".chunk.js";
};